/**
 * Badge atomic component exports
 *
 * Exports the Badge component, its props interface, variant function,
 * and variant props type for use throughout the application.
 *
 * Badge is a wrapper around shadcn/ui Badge with HEN Design System
 * variants and design tokens.
 */
export { Badge, type BadgeProps } from './Badge';
export {
  BADGE_SIZES,
  BADGE_WEIGHTS,
  badgeVariants,
  type BadgeSize,
  type BadgeVariantProps,
  type BadgeWeight,
} from './badge.variants';
